<div class="wrapper bg-area" *ngIf="!isMobile">
  <section id="pagamento-credito">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <h3 class="title">Monte seu Plano</h3>
          <div class="bar__container">
            <ul class="bar" id="bar">
              <li class="active active-step"><i class="fas fa-check"></i>Plano</li>
              <li class="active active-step"><i class="fas fa-check"></i>Dados Pessoais</li>
              <li class="active">Pagamento</li>
              <li>Segurança</li>
              <li>Confirmação</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="sample-form">
        <div class="body-faca-parte columns">
          <form class="column is-6" [formGroup]="form">

            <div class="dados-pessoais">

              <h4>DADOS DE PAGAMENTO</h4>
              <p>Agora, seus Dados de Pagamento</p>

              <div class="metodo-credito">
                <div class="area-card">
                  <img class="icon-cartao-verde icon-verde" src="./assets/img/icon-cartao-verde.png">
                </div>

                <p class="opcao-pagamento">
                  <strong>CARTÃO DE CRÉDITO</strong>
                  <br>
                  <a href="/pagamentos"><small>Trocar método de pagamento</small></a>
                </p>
              </div>

              <div class="field control-input novo-cliente" tabindex="2">
                <label>Número do Cartão</label>
                <input formControlName="cartaoNumero" [class]="fieldCssClass(form, 'cartaoNumero')"
                  (focusout)="validarFlagCartao()" type="text" placeholder="Número do Cartão"
                  mask="{{mask}}">
                <span class="bandeira {{bandeiraCartao}}"></span>
                <span class="campo-erro" *ngIf="showError('cartaoNumero')">{{getErrorMessage('cartaoNumero')}}</span>
                <span class="campo-numero-cartao" *ngIf="propostaCredito">
                  Por motivos de segurança solicitamos que o numero de seu cartao seja digitado novamente
                </span>
              </div>


              <div class="field control-input novo-cliente" tabindex="1">
                <label>Nome no Cartão</label>
                <input formControlName="cartaoTitular" [class]="fieldCssClass(form, 'cartaoTitular')" name="nomeCartao"
                  type="text" placeholder="Nome no Cartão" required>
                <span class="campo-erro" *ngIf="showError('cartaoTitular')">{{getErrorMessage('cartaoTitular')}}</span>
              </div>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>Data de Validade</label>
                <input formControlName="cartaoValidade" [class]="fieldCssClass(form, 'cartaoValidade')"
                  name="vencimento" type="text" placeholder="00/0000" mask="00/0000" mask-output="alphanumeric"
                  required>
                <span class="campo-erro"
                  *ngIf="showError('cartaoValidade')">{{getErrorMessage('cartaoValidade')}}</span>
              </div>

              <p class="opcao-cobranca"><strong>ENDEREÇO DE COBRANÇA</strong></p>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>CEP</label>
                <input formControlName="cep" [class]="fieldCssClass(form, 'cep')" (focusout)="buscarCep($event, form)"
                  name="cep" type="text" placeholder="CEP" mask="00000-000" mask-output="alphanumeric" required>
                <span class="campo-erro" *ngIf="showError('cep')">{{getErrorMessage('cep')}}</span>
              </div>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>Endereço</label>
                <input formControlName="logradouro" [class]="fieldCssClass(form, 'logradouro')" name="endereco"
                  type="text" placeholder="Endereço" required>
                <span class="campo-erro" *ngIf="showError('logradouro')">{{getErrorMessage('logradouro')}}</span>
              </div>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>Número</label>
                <input formControlName="numero" [class]="fieldCssClass(form, 'numero')" name="numero" type="text"
                  placeholder="Número">
                <span class="campo-erro" *ngIf="showError('numero')">{{getErrorMessage('numero')}}</span>
              </div>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>Complemento</label>
                <input formControlName="complemento" [class]="fieldCssClass(form, 'complemento')" name="complemento"
                  type="text" placeholder="Complemento">
                <span class="campo-erro" *ngIf="showError('complemento')">{{getErrorMessage('complemento')}}</span>
              </div>

              <app-termo-uso
                      (termoDeUsoAceitoEmit)="termoDeUsoAceitoEmit($event)"
                      [link]="'/como-funciona'"
                      [type]="'pagamento'"></app-termo-uso>

              <span class="voce-seguro">
                Você está em um ambiente seguro. Nós não alugamos ou vendemos seus dados pessoais para ninguém.
              </span>

            </div>
          </form>
          <app-resumo [result]="propostaResult" [totalDiarias]="countDiarias">
            <button type="button" (click)="submit()"
                    [disabled]="form.invalid"
                    [class]="form.invalid ? 'btn-desabilitado' : 'btn-verde'">
              CONTINUAR
            </button>
          </app-resumo>
        </div>
      </div>
    </div>
  </section>

  <div class="aviso">
    <div class="revise-dados">
      <h3>Olá, Pedro!</h3>
      <a href="" class="link-verde">Não sou o Pedro</a>
      <p>Identificamos pelo seu CPF que você já é um cliente Montreal. Para agilizar sua compra, revise os dadoes e
        confirme efetuando seu login.</p>

      <a href="" class="btn-verde">REVISAR E CONCLUIR</a>
      <a href="" class="link-verde">Preciso atualizar meu cadastro</a>
    </div>
  </div>

</div>
<div class="wrapper bg-area" *ngIf="isMobile">
  <section id="pagamento-credito-mobile">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <div class="title">
            <h3>Agora, seus Dados de Pagamento</h3>
          </div>
          <form [formGroup]="form" class="dados-pessoais">
            <div class="metodo-credito">
              <div class="area-card">
                <img class="icon-cartao-verde icon-verde" src="./assets/img/icon-cartao-verde.png">
              </div>
              <p class="opcao-pagamento">
                <strong>CARTÃO DE CRÉDITO</strong>
                <br>
                <a href="/pagamentos"><small>Trocar método de pagamento</small></a>
              </p>
            </div>
            <div class="forms">
              <div class="field control-input novo-cliente" tabindex="2">
                <label></label>
                <input formControlName="cartaoNumero"
                       [class]="fieldCssClass(form, 'cartaoNumero')"
                       (focusout)="validarFlagCartao()"
                       type="text"
                       placeholder="Número do Cartão"
                       mask="{{mask}}">
                <span id="bandeira-position" class="bandeira {{bandeiraCartao}}"></span>
                <span class="campo-erro" *ngIf="showError('cartaoNumero')">{{getErrorMessage('cartaoNumero')}}</span>
                <span class="campo-numero-cartao" *ngIf="propostaCredito">
                  Por motivos de segurança solicitamos que o numero de seu cartao seja digitado novamente
            </span>
              </div>
              <div class="field control-input novo-cliente" tabindex="1">
                <input formControlName="cartaoTitular"
                       [class]="fieldCssClass(form, 'cartaoTitular')"
                       name="nomeCartao"
                       type="text"
                       placeholder="Nome no Cartão"
                       required>
                <span class="campo-erro" *ngIf="showError('cartaoTitular')">{{getErrorMessage('cartaoTitular')}}</span>
              </div>
              <div class="field control-input novo-cliente" tabindex="1">
                <input formControlName="cartaoValidade"
                       [class]="fieldCssClass(form, 'cartaoValidade')"
                       name="vencimento"
                       type="text"
                       placeholder="00/0000"
                       mask="00/0000"
                       mask-output="alphanumeric"
                       required>
                <span class="campo-erro" *ngIf="showError('cartaoValidade')">{{getErrorMessage('cartaoValidade')}}</span>
              </div>
              <p class="opcao-cobranca"><strong>ENDEREÇO DE COBRANÇA</strong></p>
              <div class="field control-input novo-cliente" tabindex="1">
                <input formControlName="cep"
                       [class]="fieldCssClass(form, 'cep')"
                       (focusout)="buscarCep($event, form)"
                       name="cep"
                       type="text"
                       placeholder="CEP"
                       mask="00000-000"
                       mask-output="alphanumeric"
                       required>
                <span class="campo-erro" *ngIf="showError('cep')">{{getErrorMessage('cep')}}</span>
              </div>
              <div class="field control-input novo-cliente" tabindex="1">
                <input formControlName="logradouro"
                       [class]="fieldCssClass(form, 'logradouro')"
                       name="endereco"
                       type="text"
                       placeholder="Endereço"
                       required>
                <span class="campo-erro" *ngIf="showError('logradouro')">{{getErrorMessage('logradouro')}}</span>
              </div>
              <div class="field control-input novo-cliente" tabindex="1">
                <input formControlName="numero"
                       [class]="fieldCssClass(form, 'numero')"
                       name="numero"
                       type="text"
                       placeholder="Número">
                <span class="campo-erro" *ngIf="showError('numero')">{{getErrorMessage('numero')}}</span>
              </div>
              <div class="field control-input novo-cliente" tabindex="1">
                <input formControlName="complemento"
                       [class]="fieldCssClass(form, 'complemento')"
                       name="complemento"
                       type="text"
                       placeholder="Complemento">
                <span class="campo-erro" *ngIf="showError('complemento')">{{getErrorMessage('complemento')}}</span>
              </div>
              <app-termo-uso (termoDeUsoAceitoEmit)="termoDeUsoAceitoEmit($event)" [type]="'pagamento'"></app-termo-uso>
              <span class="voce-seguro">
                Você está em um ambiente seguro. Nós não alugamos ou vendemos seus dados pessoais para ninguém.
            </span>
            </div>
            <div class="column is-6 resumo-compra" *ngIf="propostaResult">
              <div class="area-fixed-resumo" *ngIf="isMobile">
                <div class="seu-plano">
                  <div class="total">
                    <div *ngIf="isCupomValido != null && isCupomValido && cupom">
                      <h4>
                        <strong>Taxa de adesão</strong>
                      </h4>
                      <p class="valores-cupom">
                        <span>De</span>
                        <span class="line-through">
                        {{propostaResult ? propostaResult.valorAdesao.toString() : '0'}}
                        </span>
                      </p>
                      <p class="valores-cupom vc2">
                        <small>Por</small>
                        <span class="valor-final"> {{propostaResult ? propostaResult.valorAdesaoDesconto.toString() : '0'}}</span>
                      </p>
                    </div>

                    <div *ngIf="!isCupomValido">
                      <h4>
                        <strong>Taxa de adesão</strong>
                      </h4>
                      <p class="valores-cupom">
                        <span></span>
                        <span class="line-through"></span>
                      </p>
                      <p class="valores-cupom vc2">
                        <small></small>
                        <span class="valor-final"> {{propostaResult.valorAdesao.toString()}}</span>
                      </p>
                    </div>

<!--                    <div *ngIf="isCupomValido != null && isCupomValido && cupom">-->
<!--                      <h4>-->
<!--                        <strong>Mensalidade</strong>-->
<!--                      </h4>-->
<!--                      <p  class="valores-cupom">-->
<!--                        <span>De</span>-->
<!--                        <span class="line-through">-->
<!--                        {{propostaResult && propostaResult.valorMensalidade? propostaResult.valorMensalidade.toString() : '0'}}-->
<!--                        </span>-->
<!--                      </p>-->
<!--                      <p  class="valores-cupom mvc2">-->
<!--                        <small>Por</small>-->
<!--                        <span class="valor-final">-->
<!--                        {{propostaResult && propostaResult.valorMensalidadeDesconto && propostaResult.valorMensalidadeDesconto.toString() != 'R$ 0,00' ? propostaResult.valorMensalidadeDesconto : propostaResult.valorMensalidade.toString()}}-->
<!--                        </span>-->
<!--                      </p>-->
<!--                    </div>-->

<!--                    <div *ngIf="!isCupomValido">-->
<!--                      <p  class="valores-cupom">-->
<!--                        <strong>Mensalidade</strong>-->
<!--                        <span></span>-->
<!--                        <span class="line-through"></span>-->
<!--                        <small></small>-->
<!--                        <span class="valor-final">{{propostaResult.valorMensalidade}}</span>-->
<!--                      </p>-->
<!--                    </div>-->

                    <div>
                      <h4>
                        <strong>Valor do Plano</strong>
                      </h4>
                      <p class="valor-plano">
                        <span class="valor">
                      <small></small>
                          {{propostaResult && propostaResult.valorMensalidadeDesconto && propostaResult.valorMensalidadeDesconto.toString() != 'R$ 0,00' ? propostaResult.valorMensalidadeDesconto : propostaResult.valorMensalidade.toString()}}
                          /
                      <span>mês</span>
                      </span>
                      </p>
                    </div>

                    <div class="btn-mobile">
                      <button [disabled]="form.invalid"
                              type="button"
                              [class]="form.invalid ? 'btn-desabilitado' : 'btn-verde'"
                              (click)="submit()"
                              class="btn-verde">
                        CONTINUAR
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>
  </section>

  <div class="aviso">
    <div class="revise-dados">
      <h3>Olá, Pedro!</h3>
      <a href="" class="link-verde">Não sou o Pedro</a>
      <p>Identificamos pelo seu CPF que você já é um cliente Montreal. Para agilizar sua compra, revise os dadoes e
        confirme efetuando seu login.</p>

      <a href="" class="btn-verde">REVISAR E CONCLUIR</a>
      <a href="" class="link-verde">Preciso atualizar meu cadastro</a>
    </div>
  </div>

</div>
